import { BaseComponent } from "../base/BaseComponent";
import { appDomain } from "../../domain/domain";
import { ICard } from "../../domain/cards/ICard";
import React from "react";
import { ButtonToolbar, Button } from "react-bootstrap";

interface CardListItemProps {
    card: ICard;
    onUpdate: (card?: ICard, deleted?: boolean) => any;
}

export class CardListItem extends BaseComponent<CardListItemProps, {}> {
    // constructor(props: CardListItemProps) {
    //     super(props);
    // }
    componentDidMount() {
        super.componentDidMount();
    }
    async deleteCard() {
        await appDomain.cardService.delete(appDomain.cardService.getId(this.props.card));
        this.props.onUpdate(this.props.card, true);
    }
    render() {
        const card = this.props.card;
        const deleteCard = this.deleteCard.bind(this)

        return (<div>
            {(card as any)._id}
            {card.sideA.title}
            {card.sideB.title}

            <ButtonToolbar>
                <Button variant="danger" onClick={deleteCard}>Delete</Button>
            </ButtonToolbar>
        </div>)

    }
}
